import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-10 sm:py-14 md:py-20 bg-cream" data-id="element-103">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-104">
        <div className="inline-flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-white rounded-full shadow-md mb-6 sm:mb-8 border-4 border-brand-gold" data-id="element-105">
          <ShieldCheck size={40} className="text-brand-gold" data-id="element-106" />
        </div>

        <h2 className="text-sm font-bold text-brand-orange tracking-widest uppercase mb-2" data-id="element-107">
          7 DÍAS
        </h2>
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 sm:mb-6" data-id="element-108">
          GARANTÍA TOTAL
        </h3>

        <p className="text-xl sm:text-2xl font-semibold text-brand-green mb-4 sm:mb-6" data-id="element-109">
          7 días para probarlo o te devolvemos el 100%
        </p>

        <p className="text-base sm:text-lg text-gray-600 mb-4 sm:mb-6 leading-relaxed" data-id="element-110">
          Aplicás los protocolos del Tomo 1 en el dormitorio de tu hijo. Probás
          el plan de comidas de la primera semana. Si no es lo que esperabas:
          sin preguntas, sin formularios, sin drama.
        </p>

        <p className="text-sm text-gray-400 font-medium" data-id="element-111">
          (Tasa de devoluciones menor al 1%)
        </p>
      </div>
    </section>;
};